import React, { useContext, useLayoutEffect } from "react";
import { useAnimateInView } from "./useAnimateInView";
import useChart from "../../Components/Chart/useChart";
import * as am4core from "@amcharts/amcharts4/core";
import am4themes_animated from "@amcharts/amcharts4/themes/animated";
import * as am4plugins_wordCloud from "@amcharts/amcharts4/plugins/wordCloud";
import Chart from "../../Components/Chart/Chart";
// import { normalizeNumbers } from "@SeemplicityDev/shared";
import { AppPreferencesContext } from "../../General/AppPreferencesProvider";
import { AppPreferencesContextType } from "../../types/AppPreferencesProvider";
import BackgroundImage from "../Assets/TagsPage/bg.png";
import AIStar from "../Assets/Common/ai-star.svg";

am4core.useTheme(am4themes_animated);
interface TagsPageProps {
  data?: {
    tags: {
      tag: string;
      count: number;
    }[];
  };
}
const TagsPage: React.FC<TagsPageProps> = ({ data }) => {
  const { ref, animateClassNames } = useAnimateInView();
  const { chartLoading, dataError, createChart } = useChart(null);
  const {
    appPreferences: { useAI },
  } = useContext(AppPreferencesContext) as AppPreferencesContextType;

  useLayoutEffect(() => {
    if (!!data) {
      let [chart] = createChart("tagsChart", am4plugins_wordCloud.WordCloud, {
        hideLegend: true,
      });
      let series = (chart as any).series?.push(
        new am4plugins_wordCloud.WordCloudSeries()
      );
      series.randomness = 0.2;
      series.rotationThreshold = 0.05;
      series.minFontSize = 16;
      series.maxFontSize = 50;
      series.data = data?.tags;
      (chart as any).fontFamily = "Courier New";

      series.dataFields.word = "tag";
      series.dataFields.value = "count";

      series.heatRules.push({
        target: series.labels.template,
        property: "fill",
        min: am4core.color("#35AF90"),
        max: am4core.color("#B9FFEC"),
        dataField: "value",
      });

      return () => {
        (chart as any)?.dispose();
      };
    }
  }, [data]);

  return (
    <div className={`eoy-page tags-page ${animateClassNames}`} ref={ref}>
      <img src={BackgroundImage} alt="Background" className="bg-image" />
      <h2 className="page-title">Most Used Tags{useAI ? "*" : ""}</h2>
      <div className={`tags-container ${useAI ? "use-ai" : ""}`}>
        {useAI && <img src={AIStar} alt="AI" className="ai-star" />}
        <Chart
          chartLoading={chartLoading}
          chartName="tagsChart"
          chartError={dataError}
          chartData={!!data}
        />
      </div>
      {useAI && (
        <div className="ai-text">
          *AI-generated tag groups based on your data to reduce noise
        </div>
      )}
    </div>
  );
};

export default TagsPage;
